import { Box, SwipeableDrawer } from "@material-ui/core";
import { DrawerSide } from "../../../models/interfaces";
import customDrawerStyles from "./CustomDrawer.styles";

interface CustomProps {
  side: DrawerSide;
  isOpen: boolean;
  toggleDrawer: any;
  drawerTitle?: JSX.Element;
  drawerTitleClass?: any;
  drawerBody: JSX.Element;
  drawerStyle?: any;
}

const CustomDrawer = (props: CustomProps) => {
  const classes = customDrawerStyles();
  const appliedClasses = props.drawerStyle
    ? props.drawerStyle
    : { paper: classes.borders };

  const appliedTitleClasses = props.drawerTitleClass ? props.drawerTitleClass : classes.drawerTitleClass;

  return (
    <SwipeableDrawer
      classes={appliedClasses}
      anchor={props.side}
      open={props.isOpen}
      onClose={props.toggleDrawer(false)}
      onOpen={props.toggleDrawer(true)}
    >
      <Box className={appliedTitleClasses as any}>
        {props.drawerTitle ? props.drawerTitle : null}
      </Box>
      {props.drawerBody}
    </SwipeableDrawer>
  );
};

export default CustomDrawer;
